module.exports = __webpack_public_path__ + "static/media/close.d8efb2b7.svg";